const dateInputFormat = {
  mask: 'TTTT-AB-CD',
  tokens: {
    T: { pattern: /[0-9]/ },
    A: { pattern: /[0-1]/ },
    B: { pattern: /[0-9]/ },
    C: { pattern: /[0-3]/ },
    D: { pattern: /[0-9]/ },
  },
};

export default dateInputFormat;
